"use client"
import React from 'react'
import Image from "next/image";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import SectionShapes from "@shared/SectionShapes";

function Counter({data=[]}) {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <section className="relative py-14 px-6 overflow-hidden">

      {/* Background image */}
      <Image
        src="/images/counter_bg.webp"
        alt="Counter Number"
        fill
        className="object-cover object-center"
        priority={false}
        aria-hidden="true"
      />
      {/* Dark overlay so content stays readable */}
      <div className="absolute inset-0 bg-ink/80 pointer-events-none" />

      <SectionShapes variant="dark" />

      {/* Glass card */}
      <div
        ref={ref}
        className="relative max-w-300 mx-auto rounded-2xl overflow-hidden bg-white/5 backdrop-blur-xl saturate-150 border border-ink-foreground/12 shadow-2xl"
      >
        <div className="grid grid-cols-2 sm:flex sm:items-center sm:justify-between divide-x divide-white/10 py-6 sm:py-10">
          {data.map(({ id, value, suffix, label }, i) => (
            <div
              key={id}
              className={`sm:flex-1 flex flex-col items-center gap-2 sm:gap-3 px-4 py-5 sm:px-8 sm:py-0 ${i >= 2 ? 'border-t border-white/10 sm:border-t-0' : ''}`}
            >
              <span className="font-heading font-extralight text-3xl sm:text-5xl text-white leading-none tracking-tight">
                {inView && <CountUp end={value} duration={2.5} />}
                <span className="text-primary">{suffix}</span>
              </span>
              <p className="text-ink-foreground font-medium text-sm sm:text-md tracking-[0.04em] text-center">
                {label}
              </p>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}

export default Counter
